<template>
    <span v-if="templateArgs.showShortDate">{{shortDateFormat}}</span>
    <span v-else-if="templateArgs.showHourFormat">{{hourFormat}}</span>
    <span v-else>{{longDateFormat}}</span>

</template>

<script>
    export default {
        name: "datetimeCellDisplayTemplate",
        data() {
            return {
                templateArgs: {},
                dateValue: ''
            };
        },
        mounted() {
            this.convertFromUtcToLocal()
        },
        methods: {
            convertFromUtcToLocal() {
                if (this.templateArgs.dateValue) {
                    // this.dateValue = this.$helpers.convertFromUtcToLocal(this.templateArgs.dateValue);
                    // console.log(this.templateArgs.dateValue)
                    let dateUtc = new Date(this.templateArgs.dateValue);
                    if (dateUtc) {
                        this.dateValue = new Date(Date.UTC(dateUtc.getFullYear(),
                            dateUtc.getMonth(), dateUtc.getDate(), dateUtc.getHours(), dateUtc.getMinutes(), dateUtc.getSeconds()));
                    }
                }
            }
        },
        computed: {
            hourFormat() {
                if (!this.dateValue) {
                    return '';
                }

                let hours = '' + this.dateValue.getHours();
                let minutes = '' + this.dateValue.getMinutes();

                if (hours.length < 2) hours = '0' + hours;
                if (minutes.length < 2) minutes = '0' + minutes;

                return [hours, minutes].join(':');
            },
            shortDateFormat() {
                if (!this.dateValue) {
                    return '';
                }

                let month = '' + (this.dateValue.getMonth() + 1);


let day = '' + this.dateValue.getDate();


let year = this.dateValue.getFullYear();

                if (month.length < 2) month = '0' + month;
                if (day.length < 2) day = '0' + day;

                return [day, month, year].join('.');
            },
            longDateFormat() {
                if (!this.dateValue) {
                    return '';
                }

                let month = '' + (this.dateValue.getMonth() + 1);


let day = '' + this.dateValue.getDate();


let year = this.dateValue.getFullYear();


let hours = '' + this.dateValue.getHours();


let minutes = '' + this.dateValue.getMinutes();


let seconds = '' + this.dateValue.getSeconds();

                if (month.length < 2) month = '0' + month;
                if (day.length < 2) day = '0' + day;
                if (hours.length < 2) hours = '0' + hours;
                if (minutes.length < 2) minutes = '0' + minutes;
                if (seconds.length < 2) seconds = '0' + seconds;

                if (this.templateArgs.hideSconds) {
                    return [day, month, year].join('.') + ' ' + [hours, minutes].join(':');
                } else {
                    return [day, month, year].join('.') + ' ' + [hours, minutes, seconds].join(':');
                }
            }
        }
    };
</script>
